import {clearButtonStyles} from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchClearButton"
import {dateRangeStyles} from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchFieldDateRange"
import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags"
import { orderHistoryTableStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistoryTable"
import { BaseTheme } from "@insite/mobius/globals/baseTheme"
import { breakpointMediaQueries } from "@insite/mobius/utilities"
import { css } from "styled-components"

clearButtonStyles.clearButton= {
    mergeCss:true,
    variant: "secondary",
    css: css`
        float: right;
    `,
}

orderHistoryTableStyles.container = {
    css: css`
        overflow: auto;
        margin-top: 30px !important;
    `,
}

orderHistorySearchTagsStyles.appliedFilterTag = {
        css:css`
            button {
                min-width: auto;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `
}

dateRangeStyles.fromDate={
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-right: 5px;
        `,
        formInputWrapper: css`
            @media (max-width: 575px) {
                div.react-datetime-picker {
                    padding: 0 5px !important;
                }
                span[class^="IconWrapper"] {
                    width: 30px !important;
                }
            }
            @media (min-width: 992px) and (max-width: 1100px) {
                span[class^="IconWrapper"] {
                    padding-left: 2px !important;
                    width: 30px !important;
                }
            }
        `,
    },
}

dateRangeStyles.toDate={
    cssOverrides: {
        inputSelect: css`
            width: 100%;
        `,
        formField: css`
            padding-left: 5px;
        `,
        formInputWrapper: css`
                @media (max-width: 575px) {
                    div.react-datetime-picker {
                        padding: 0 5px !important;
                    }
                    span[class^="IconWrapper"] {
                        width: 30px !important;
                    }
                }
                div[class^="react-calendar"]{
                    ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        css`
                            left: auto;
                            right: 0;
                        `,
                        css`
                            left: auto;
                            right: 0;
                        `,
                    ])}
                }
            `,
    },
    labelProps: {
        color: "common.background",
    },
}